import { Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';

const WIDTH = 106.5;
const HEIGHT = 6.5;
const STROKE_WIDTH = HEIGHT;

const HALF_STROKE = STROKE_WIDTH / 2;

@Component({
  selector: 'app-chart-line',
  templateUrl: './chart-line.component.html',
  styleUrls: ['./chart-line.component.scss']
})
export class ChartLineComponent {

  @Input() @HostBinding('style.width') width = 'unset';
  @Input() @HostBinding('style.height') height = 'unset';
  @Input() value: number;
  @Input() orientation = 'horizontal';

  get type() {
    return this.orientation === 'vertical'
      ? 'v'
      : 'h';
  }

  get viewBox() {
    return `0 0 ${this.type === 'v'
      ? `${HEIGHT} ${WIDTH}`
      : `${WIDTH} ${HEIGHT}`}`;
  }

  get strokeWidth() {
    return STROKE_WIDTH;
  }

  getLinePath(percent: number) {
    let y = HALF_STROKE;
    let drawingOperation = 'h';
    if (this.type === 'v') {
      y = WIDTH - HALF_STROKE;
      drawingOperation = 'v-';
    }
    return `M${HALF_STROKE},${y} ${drawingOperation}${Math.max(0, Math.min(100, Number(percent) ?? 0))}`;
  }

  getMarkerPath(reference: number) {
    const position = (reference * 100) + HALF_STROKE;

    let startX = position;
    let startY = .75;
    let drawingOperation = 'v';
    if (this.type === 'v') {
      [startX, startY] = [startY, startX];
      drawingOperation = 'h';
    }

    return `M${startX},${startY} ${drawingOperation}${STROKE_WIDTH - 1.5}`;
  }
}
